import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Enregistrement du service worker (PWA installable)
if ('serviceWorker' in navigator && typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* silencieux en dev */ });
  });
  // Patch iPhone Safari : quand un nouveau SW s'active (nouvelle version du cache),
  // il nous envoie `SW_UPDATED` → on recharge la page UNE SEULE FOIS (sentinel
  // localStorage) pour que le navigateur demande le nouveau bundle JS/CSS.
  // Évite le piège "l'utilisateur ouvre la PWA, reste bloqué sur l'ancienne version".
  try {
    navigator.serviceWorker.addEventListener('message', (event) => {
      const data = event && event.data;
      if (!data || data.type !== 'SW_UPDATED' || !data.cache) return;
      const key = 'c2r-sw-version';
      let previous = null;
      try { previous = localStorage.getItem(key); } catch (_) { /* no-op */ }
      if (previous !== data.cache) {
        try { localStorage.setItem(key, data.cache); } catch (_) { /* no-op */ }
        // Reload uniquement si on avait déjà une version antérieure (évite une
        // boucle de reload au premier chargement complètement neuf).
        if (previous) {
          window.location.reload();
        }
      }
    });
  } catch (_) { /* no-op */ }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
